import { ComponentStyleConfig } from '@chakra-ui/react';

interface ComponentStyles {
  [key: string]: ComponentStyleConfig;
}

// Component-specific theme overrides
export const components: ComponentStyles = {
  Button: {
    baseStyle: {
      fontWeight: 'semibold',
      borderRadius: 'md',
    },
    variants: {
      solid: {
        bg: 'primary.500',
        color: 'white',
        _hover: {
          bg: 'primary.600',
        },
        _active: {
          bg: 'primary.700',
        },
      },
      outline: {
        borderColor: 'primary.500',
        color: 'primary.500',
        _hover: {
          bg: 'primary.50',
        },
      },
      ghost: {
        color: 'primary.500',
        _hover: {
          bg: 'primary.50',
        },
      },
    },
  },
  Input: {
    baseStyle: {
      field: {
        borderRadius: 'md',
      },
    },
    variants: {
      outline: {
        field: {
          borderColor: 'border.input',
          _hover: {
            borderColor: 'border.input',
          },
          _focus: {
            borderColor: 'blue.500',
            boxShadow: 'outline',
          },
          color: 'text.primary',
        },
      },
    },
    defaultProps: {
      variant: 'outline',
    },
  },
  Select: {
    baseStyle: {
      field: {
        borderRadius: 'md',
      },
    },
    variants: {
      outline: {
        field: {
          borderColor: 'border.input',
          _hover: {
            borderColor: 'border.input',
          },
          _focus: {
            borderColor: 'blue.500',
            boxShadow: 'outline',
          },
          color: 'text.primary',
        },
      },
    },
    defaultProps: {
      variant: 'outline',
    },
  },
  Textarea: {
    baseStyle: {
      borderRadius: 'md',
    },
    variants: {
      outline: {
        borderColor: 'border.input',
        _hover: {
          borderColor: 'border.input',
        },
        _focus: {
          borderColor: 'blue.500',
          boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)',
        },
        _invalid: {
          borderColor: 'red.500',
          boxShadow: '0 0 0 1px var(--chakra-colors-red-500)',
        },
      },
    },
    defaultProps: {
      variant: 'outline',
    },
  },
  FormLabel: {
    baseStyle: {
      color: 'text.primary',
      marginBottom: '2',
      fontWeight: 'medium',
    },
  },
  FormError: {
    baseStyle: {
      text: {
        fontSize: 'sm',
        color: 'red.500',
        marginTop: '1',
      },
    },
  },
  Card: {
    baseStyle: {
      container: {
        borderWidth: '1px',
        borderColor: 'border.card',
        borderRadius: 'xl',
        overflow: 'hidden',
        bg: 'bg.card',
      },
    },
  },
  Table: {
    baseStyle: {
      th: {
        borderColor: 'border.table',
      },
      td: {
        borderColor: 'border.table',
      },
    },
    variants: {
      simple: {
        th: {
          borderColor: 'border.table',
          borderBottom: '1px solid',
        },
        td: {
          borderColor: 'border.table',
          borderBottom: '1px solid',
        },
      },
    },
    defaultProps: {
      variant: 'simple',
    },
  },
  Menu: {
    baseStyle: {
      button: {
        bg: 'bg.card',
        color: 'text.primary',
        borderWidth: '1px',
        borderColor: 'border.input',
        _hover: { bg: 'bg.hover' },
        _expanded: { bg: 'bg.hover' },
      },
      list: {
        bg: 'bg.card',
        borderColor: 'border.input',
      },
      item: {
        bg: 'bg.card',
        _hover: { bg: 'bg.hover' },
        _focus: { bg: 'bg.hover' },
      },
    },
  },
  Accordion: {
    baseStyle: {
      container: {
        borderColor: 'border.input',
      },
      button: {
        color: 'text.primary',
        _hover: {
          bg: 'bg.hover',
        },
      },
      panel: {
        color: 'text.primary',
      },
    },
  },
};
